import KformComponent from '../kform-component';
import Card from '~/scripts/services/model/card';

export default class PasswordComponent extends KformComponent {
	/**
	 * @param {import('@knitiv/api-client-javascript').ComponentPassword | undefined} settings
	 */
	constructor(settings = undefined) {
		super(settings);
		this.allowToggle = settings?.allowToggle ?? true;
		this.autofocus = settings?.autofocus ?? false;
		this.defaultValue = settings?.defaultValue ?? '';
		this.disabled = settings?.disabled ?? false;
		this.event = {
			onChange: undefined,
			...settings?.event,
		};
		this.input = true;
		this.inputType = settings?.inputType ?? 'password';
		this.kdata = {
			submit: true,
			...settings?.kdata,
		};
		this.persistent = settings?.persistent ?? true;
		this.placeholder = settings?.placeholder ?? '';
		this.prefix = settings?.prefix ?? '';
		this.process = {
			disabled: null,
			hidden: null,
			list: [],
			...settings?.process,
		};
		this.protected = settings?.protected ?? false;
		this.rule = {
			disabled: null,
			hidden: null,
			...settings?.rule,
		}
		this.showPass = settings?.showPass ?? false;
		this.suffix = settings?.suffix ?? '';
		this.validate = {
			maxLength: null,
			minLength: null,
			pattern:    '',
			...settings?.validate,
			card: new Card(settings?.validate?.card ?? '0-1'),
		};
	}

	/**
	 * @returns {Set<string>}
	 */
	getSubmissionKeys() {
		return new Set([
			'name',
		]);
	}
}
